import { Controller } from "@hotwired/stimulus";
import { throttle } from "lodash-es";

export default class extends Controller {
  static values = {
    url: { type: String, default: null },
    throttleMs: { type: Number, default: 5000 },
  };

  static outlets = ["chat-message-form"];

  connect() {
    this.throttledSendReceipt = throttle(this.sendReceipt.bind(this), this.throttleMsValue, {
      leading: true,
      trailing: false,
    });
    this.boundHandleInteraction = this.handleInteraction.bind(this);
    this.throttledSendReceipt();
  }

  disconnect() {
    if (this.editorElement) {
      this.editorElement.removeEventListener("trix-change", this.boundHandleInteraction);
      this.editorElement.removeEventListener("trix-focus", this.boundHandleInteraction);
    }
    if (this.throttledSendReceipt?.cancel) {
      this.throttledSendReceipt.cancel();
    }
  }

  initListeners() {
    if (this.editorElement) {
      this.editorElement.addEventListener("trix-change", this.boundHandleInteraction);
      this.editorElement.addEventListener("trix-focus", this.boundHandleInteraction);
    }
  }

  handleInteraction() {
    this.throttledSendReceipt();
  }

  chatMessageFormOutletConnected(outlet, element) {
    this.editorElement = outlet.trixInputTarget;
    this.initListeners();
  }

  sendReceipt() {
    const csrfToken = document.querySelector("meta[name=csrf-token]")?.content;

    fetch(this.urlValue, {
      headers: {
        "X-CSRF-Token": csrfToken,
      },
      method: "PUT",
    });
  }
}
